import type { ScriptProperties } from "./ScriptProperties";
export interface ArgoCDGitCommitProperties {
    "Octopus.Action.ArgoCD.CommitMessageSummary": string;
    "Octopus.Action.ArgoCD.CommitMessageDescription": string;
    "Octopus.Action.ArgoCD.CommitMethod": string;
}
export interface ArgoCDImageUpdateProperties extends ScriptProperties, ArgoCDGitCommitProperties {
}
export enum GitCommitMethods {
    DirectCommit = "DirectCommit",
    PullRequest = "PullRequest"
}
